import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tag", "hiddenInputs"];
  static values = {
    selected: { type: Array, default: [] }
  };

  connect() {
    // Track selections by hobby NAME. Tags expose the name via data-hobby
    // (dataset.hobby), and InterestsController#update reads params[:hobbies]
    // and resolves records by name. (Earlier code read a non-existent
    // dataset.hobbyId and submitted hobby_ids[], so values came through blank.)
    this.selectedValue = this.selectedValue.map(String);
    const selectedSet = new Set(this.selectedValue);
    this.tagTargets.forEach(tag => {
      tag.classList.toggle("selected", selectedSet.has(tag.dataset.hobby));
    });
    this.renderHiddenInputs();
  }

  filter(event) {
    const searchTerm = event.target.value.toLowerCase();
    this.tagTargets.forEach(tag => {
      tag.style.display = tag.textContent.toLowerCase().includes(searchTerm) ? "flex" : "none";
    });
  }

  toggle(event) {
    const tag = event.currentTarget;
    const name = tag.dataset.hobby;
    if (!name) return;
    if (this.selectedValue.includes(name)) {
      this.selectedValue = this.selectedValue.filter(h => h !== name);
      tag.classList.remove("selected");
    } else {
      this.selectedValue = [...this.selectedValue, name];
      tag.classList.add("selected");
    }
    this.dispatchUpdate();
    this.renderHiddenInputs();
  }

  dispatchUpdate() {
    this.dispatch("update", { detail: { count: this.selectedValue.length } });
  }

  renderHiddenInputs() {
    if (!this.hasHiddenInputsTarget) return;
    this.hiddenInputsTarget.innerHTML = "";
    this.selectedValue.forEach(value => {
      const input = document.createElement("input");
      input.type = "hidden";
      // hobbies[] with the name — InterestsController#update reads params[:hobbies].
      input.name = "hobbies[]";
      input.value = value;
      this.hiddenInputsTarget.appendChild(input);
    });
  }
}
